import { useState } from 'react'
import { useNavigate } from 'react-router'
import { useBahasa } from '../../../app/i18n'
import { useBuatTenant, useDaftarTenant } from '../../../domains/tenancy/api'
import { istilah } from '../../../shared/lib/istilah'
import { angka } from '../../../shared/lib/waktu'
import {
  Baris, Bendera, Chip, Gagal, Isian, KepalaHalaman, Kosong, Memuat, Panel, Tabel, Tombol,
} from '../../../shared/ui'

/** Warna mode dipakai di dua layar, jadi aturannya satu tempat. */
export const NADA_MODE = { live: 'ok', test: 'warn', draft: 'idle' }

export default function DaftarTenant() {
  const { t, locale } = useBahasa()
  const navigate = useNavigate()
  const q = useDaftarTenant()
  const buat = useBuatTenant()
  const [membuat, setMembuat] = useState(false)
  const [nama, setNama] = useState('')

  const items = q.data ?? []

  return (
    <>
      <KepalaHalaman
        judul={t('adm.tenantJudul')}
        keterangan={t('adm.tenantKeterangan')}
        aksi={
          <Tombol onClick={() => { setMembuat(!membuat); buat.reset(); setNama('') }}>
            {membuat ? t('umum.batal') : t('adm.tenantBaru')}
          </Tombol>
        }
      />

      {membuat && (
        <Panel judul={t('adm.tenantBaru')}>
          <div className="p-3.5 flex flex-col gap-3 max-w-[52ch]">
            <label className="flex flex-col gap-1.5">
              <span className="text-[11px] font-semibold uppercase tracking-[.07em] text-ink3">
                {t('adm.namaTenant')}
              </span>
              <Isian
                autoFocus
                value={nama}
                onChange={(e) => setNama(e.target.value)}
                placeholder={t('adm.namaTenantContoh')}
              />
            </label>

            {/* Dikatakan SEBELUM tombolnya ditekan, bukan sesudah. Tenant lahir
                'draft' dan diam total — kalau itu baru diketahui setelah orang
                bertanya "kenapa botnya tidak jalan", kita sudah menghabiskan
                waktunya. */}
            <Bendera nada="info">{t('adm.lahirDraft')}</Bendera>

            {buat.isError && (
              <Bendera nada="bad" role="alert">{buat.error?.message}</Bendera>
            )}

            <div>
              <Tombol
                disabled={!nama.trim() || buat.isPending}
                onClick={() =>
                  buat.mutate(
                    { name: nama.trim() },
                    {
                      onSuccess: (d) => {
                        setMembuat(false)
                        setNama('')
                        // Langsung ke detailnya: tenant yang baru dibuat belum bisa
                        // apa-apa, dan layar berikutnya yang menjelaskan apa yang kurang.
                        navigate(`/tenant/${d.id}`)
                      },
                    },
                  )
                }
              >
                {buat.isPending ? t('adm.membuat') : t('adm.buatTenant')}
              </Tombol>
            </div>
          </div>
        </Panel>
      )}

      <Panel>
        {q.isLoading && <Memuat tinggi={4} />}
        {q.isError && <Gagal galat={q.error} ulangi={q.refetch} />}
        {q.data && items.length === 0 && <Kosong judul={t('adm.belumAdaTenant')} />}

        {/* KOLOMNYA MENJAWAB "KLIEN MANA YANG SEDANG BERMASALAH".
            Bentuk lamanya menampilkan Tipe, Mode, Zona waktu, dan Dibuat — data induk
            yang nyaris tidak pernah jadi alasan orang membuka daftar tenant. Zona waktu
            dan tanggal lahir pindah ke detail tenant, tempat pertanyaannya memang
            "tenant ini bagaimana", bukan "klien mana". */}
        {items.length > 0 && (
          <Tabel
            kepala={[
              t('adm.kolNama'), t('adm.kolMode'), t('adm.kolSambungan'),
              t('adm.kolOrang'), t('adm.kolDm30'), t('adm.kolProspek'), t('adm.kolToken30'),
            ]}
          >
            {items.map((x) => (
              <Baris key={x.id} onClick={() => navigate(`/tenant/${x.id}`)}>
                <td>
                  <span className="font-semibold">{x.name}</span>
                  <span className="block text-[11px] text-ink3">
                    {istilah(t, 'jenisTenant', x.type)}
                  </span>
                </td>
                <td><Chip nada={NADA_MODE[x.mode] ?? 'idle'}>{istilah(t, 'mode', x.mode)}</Chip></td>
                {/* NOL SAMBUNGAN = klien itu tidak menerima apa pun. Ditandai merah, bukan
                    dibiarkan jadi angka 0 di antara angka lain — nol di kolom hitungan
                    terbaca seperti data yang gagal dimuat. */}
                <td className="tabular">
                  {x.sambungan === 0
                    ? <Chip nada="bad">{t('adm.tanpaSambungan')}</Chip>
                    : x.sambungan}
                </td>
                <td className="tabular">{x.orang}</td>
                <td className="tabular">{angka(x.dm_30h, locale)}</td>
                <td className="tabular">{angka(x.prospek, locale)}</td>
                <td className="tabular">{angka(x.token_30h, locale)}</td>
              </Baris>
            ))}
          </Tabel>
        )}
      </Panel>
    </>
  )
}
